import { cloneDeep } from 'lodash';
import pdfConfig from './helper';
import { getLabelOptions } from '../utils';
import { convertBoolLabel } from '../exportHelper';

const HeaderTable = ({ t }) => [
  t('label.itemId'),
  t('label.errorMessage'),
  t('label.name'),
  t('label.description'),
  t('label.serviceProductCode'),
  t('label.uom'),
  t('label.chargeType'),
  t('label.status'),
  t('label.isParent'),
  t('label.isChild'),
  t('label.serviceType'),
  t('label.glAccount'),
  t('label.taxCode'),
  t('label.uomName'),
  t('label.productFamily'),
  t('label.productLine'),
  t('label.productType'),
];

const convertJson2Pdf = ({ data, t, title, fileName, uomList, ...rest }) => {
  const Header = cloneDeep(HeaderTable({ t }));
  const newListData = data.map(item => {
    const newItem = [];
    if (item && typeof item === 'object') {
      newItem.push(item.itemId ? item.itemId : '');
      newItem.push(item.errorMessage ? item.errorMessage : '');
      newItem.push(item.name ? item.name : '');
      newItem.push(item.description ? item.description : '');
      newItem.push(item.serviceProductCode ? item.serviceProductCode : '');
      newItem.push(item.uom ? item.uom : '');
      newItem.push(getLabelOptions({ item, t, fieldName: 'chargeType', fieldOption: 'chargeType' }));
      newItem.push(getLabelOptions({ item, t, fieldName: 'status', fieldOption: 'itemServiceStatus' }));
      newItem.push(convertBoolLabel({ t, value: item.isParent }));
      newItem.push(convertBoolLabel({ t, value: item.isChild }));
      newItem.push(getLabelOptions({ item, t, fieldName: 'serviceType', fieldOption: 'serviceType' }));
      newItem.push(item.glAccount ? item.glAccount : '');
      newItem.push(item.taxCode ? item.taxCode : '');
      newItem.push(item.uomName ? item.uomName : '');
      newItem.push(item.productFamily ? item.productFamily : '');
      newItem.push(item.productLine ? item.productLine : '');
      newItem.push(item.productType ? item.productType : '');
    }
    return newItem;
  });
  return pdfConfig({ data: newListData, Header, title, fileName, fontSize: 5, cellPadding: 2, ...rest });
};

export default convertJson2Pdf;
